import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ff460eaac120968402436bec119fc9b9.jpg"
          alt="Custom tailored suit"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center w-full">
        <div className="max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-6 py-2 mb-8">
            <i className="ri-award-line text-[#C4A962] mr-2"></i>
            <span className="text-white text-sm font-medium">Bespoke Tailors in Wellesley, MA</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Exquisite Custom Clothing<br />
            <span className="text-[#C4A962]">Tailored to Perfection</span>
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-gray-200 mb-12 max-w-3xl mx-auto leading-relaxed">
            Experience the finest bespoke suits, shirts, and blazers crafted with 30+ precise measurements. We make house and office calls throughout Massachusetts.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/contact"
              className="bg-[#C4A962] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#B39952] transition-all transform hover:scale-105 shadow-xl whitespace-nowrap w-full sm:w-auto"
            >
              <i className="ri-calendar-line mr-2"></i>
              Call for Appointment
            </Link>
            <a
              href="tel:781-237-3166"
              className="bg-white text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap w-full sm:w-auto"
            >
              <i className="ri-phone-line mr-2"></i>
              Call 781-237-3166
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="mt-16 flex flex-wrap justify-center items-center gap-8 text-white">
            <div className="flex items-center">
              <i className="ri-star-fill text-[#C4A962] text-2xl mr-2"></i>
              <div className="text-left">
                <div className="font-bold text-lg">4.9/5 Rating</div>
                <div className="text-sm text-gray-300">127+ Reviews</div>
              </div>
            </div>
            <div className="flex items-center">
              <i className="ri-shield-check-line text-[#C4A962] text-2xl mr-2"></i>
              <div className="text-left">
                <div className="font-bold text-lg">Licensed and Insured</div>
                <div className="text-sm text-gray-300">Certified Tailors</div>
              </div>
            </div>
            <div className="flex items-center">
              <i className="ri-time-line text-[#C4A962] text-2xl mr-2"></i>
              <div className="text-left">
                <div className="font-bold text-lg">55+ Years</div>
                <div className="text-sm text-gray-300">Experience</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;